<template>
  <v-app>
    <v-container>
      <PitchEnglishHomeApplicationTemplate>
        <router-view />
        <!-- Card 86akqxu0h: aviso de formulario pendente ao entrar. -->
        <pending-surveys-prompt profile="partner" />
        <!-- Card 17trt6jfxt2: presença pendente das aulas encerradas. -->
        <pending-attendance-prompt />
      </PitchEnglishHomeApplicationTemplate>
    </v-container>
  </v-app>
</template>
<script>
import PitchEnglishHomeApplicationTemplate from "@/template/ApplicationTemplate";
import PendingSurveysPrompt from "@/components/surveys/PendingSurveysPrompt.vue";
import PendingAttendancePrompt from "@/components/attendance/PendingAttendancePrompt.vue";
export default {
  components: {
    PitchEnglishHomeApplicationTemplate,
    PendingSurveysPrompt,
    PendingAttendancePrompt,
  },
};
</script>
